import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, FormHelperText, Grid, TextField, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { InvoiceDetailsSettingsFormData } from 'models/forms';

/**
 * DD-3700: what a German lab prints besides its VAT number: the Steuernummer, the company
 * register details a GmbH must show on invoices (§ 35a GmbHG), and the small business status
 * (§ 19 UStG, no VAT charged).
 */
const GermanCompanyFields: FC<{ formik: FormikProps<InvoiceDetailsSettingsFormData> }> = ({ formik }) => {
    const { t: translate } = useTranslation(['lab-settings']);

    return (
        <>
            <Grid item sm={12} md={6}>
                <TextField
                    id="taxNumber"
                    label={translate('lab-settings:TAX_NUMBER')}
                    fullWidth
                    {...formik.getFieldProps('taxNumber')}
                    helperText={translate('lab-settings:TAX_NUMBER_INFO')}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle2">{translate('lab-settings:COMPANY_REGISTER')}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {translate('lab-settings:COMPANY_REGISTER_INFO')}
                </Typography>
            </Grid>
            <Grid item sm={12} md={6}>
                <TextField
                    id="registeredOffice"
                    label={translate('lab-settings:REGISTERED_OFFICE')}
                    fullWidth
                    {...formik.getFieldProps('registeredOffice')}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <TextField
                    id="registerCourt"
                    label={translate('lab-settings:REGISTER_COURT')}
                    fullWidth
                    {...formik.getFieldProps('registerCourt')}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <TextField
                    id="registerNumber"
                    label={translate('lab-settings:REGISTER_NUMBER')}
                    fullWidth
                    {...formik.getFieldProps('registerNumber')}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <TextField
                    id="managingDirectors"
                    label={translate('lab-settings:MANAGING_DIRECTORS')}
                    fullWidth
                    {...formik.getFieldProps('managingDirectors')}
                    helperText={translate('lab-settings:MANAGING_DIRECTORS_INFO')}
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox {...formik.getFieldProps({ name: 'smallBusinessExemption', type: 'checkbox' })} />
                    }
                    label={translate('lab-settings:SMALL_BUSINESS_EXEMPTION')}
                />
                <FormHelperText>{translate('lab-settings:SMALL_BUSINESS_EXEMPTION_INFO')}</FormHelperText>
            </Grid>
        </>
    );
};

export default GermanCompanyFields;
